import { render, staticRenderFns } from "./DialogPrompt.vue?vue&type=template&id=e6f2e1d0&scoped=true&"
import script from "./DialogPrompt.vue?vue&type=script&lang=ts&"
export * from "./DialogPrompt.vue?vue&type=script&lang=ts&"
import style0 from "./DialogPrompt.vue?vue&type=style&index=0&id=e6f2e1d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f2e1d0",
  null
  
)

export default component.exports